var map = {
	"./canals5D/icon-5D-items.svg": "43d0",
	"./canals5D/icon-5D-selected.svg": "4abc",
	"./canals5D/icon-5D.svg": "cfed",
	"./canals5D/icon-expertmode-selected.svg": "0324",
	"./canals5D/icon-expertmode.svg": "da12",
	"./canals5D/icon-hamburger.svg": "2763",
	"./canals5D/icon-info-selected.svg": "ddc4",
	"./canals5D/icon-lang-checkbox.svg": "501c",
	"./canals5D/icon-logo.svg": "7ede",
	"./canals5D/icon-marker-5d.svg": "c94e",
	"./canals5D/icon-marker-hotspot.svg": "fe46",
	"./canals5D/icon-pause.svg": "cb1c",
	"./canals5D/icon-play-audio.svg": "1993",
	"./canals5D/icon-play-video.svg": "6a3a",
	"./canals5D/icon-play.svg": "0d3c",
	"./canals5D/icon-position.svg": "0fd3",
	"./canals5D/icon-route-remove.svg": "6340",
	"./canals5D/icon-route.svg": "798b",
	"./canals5D/icon-search.svg": "61ab",
	"./canals5D/icon-selected-route.svg": "9574",
	"./canals5D/icon-selected-theme.svg": "3745",
	"./canals5D/icon-theme-remove.svg": "eabc",
	"./canals5D/icon-timeline-selected.svg": "7397",
	"./canals5D/map-footer-gradiant.svg": "2fbb",
	"./dordrecht5D/icon-5D-items.svg": "809a",
	"./dordrecht5D/icon-5D-selected.svg": "d21b",
	"./dordrecht5D/icon-5D.svg": "7b60",
	"./dordrecht5D/icon-expertmode-selected.svg": "9150",
	"./dordrecht5D/icon-expertmode.svg": "c144",
	"./dordrecht5D/icon-hamburger.svg": "4739",
	"./dordrecht5D/icon-info-selected.svg": "528e",
	"./dordrecht5D/icon-lang-checkbox.svg": "b3d3",
	"./dordrecht5D/icon-logo.svg": "d71c",
	"./dordrecht5D/icon-marker-5d.svg": "7dd2",
	"./dordrecht5D/icon-marker-hotspot.svg": "9061",
	"./dordrecht5D/icon-pause.svg": "dade",
	"./dordrecht5D/icon-play-audio.svg": "a60b",
	"./dordrecht5D/icon-play-video.svg": "d666",
	"./dordrecht5D/icon-play.svg": "5c2d",
	"./dordrecht5D/icon-position.svg": "2378",
	"./dordrecht5D/icon-route-remove.svg": "afc0",
	"./dordrecht5D/icon-route.svg": "f02f",
	"./dordrecht5D/icon-search.svg": "df74",
	"./dordrecht5D/icon-selected-route.svg": "2ec1",
	"./dordrecht5D/icon-selected-theme.svg": "edd9",
	"./dordrecht5D/icon-theme-remove.svg": "e381",
	"./dordrecht5D/icon-timeline-selected.svg": "228c",
	"./dordrecht5D/map-footer-gradiant.svg": "9ff4",
	"./featured-article-placeholder.svg": "058c",
	"./huygens/icon-5D-items.svg": "6336",
	"./huygens/icon-5D-selected.svg": "0936",
	"./huygens/icon-5D.svg": "1d63",
	"./huygens/icon-expertmode-selected.svg": "eebf",
	"./huygens/icon-expertmode.svg": "40a6",
	"./huygens/icon-hamburger.svg": "1c91",
	"./huygens/icon-info-selected.svg": "cb55",
	"./huygens/icon-lang-checkbox.svg": "e2eb",
	"./huygens/icon-logo.svg": "3ae5",
	"./huygens/icon-marker-5d.svg": "31a6",
	"./huygens/icon-marker-hotspot.svg": "1a4d",
	"./huygens/icon-message.svg": "3114",
	"./huygens/icon-pause.svg": "d727",
	"./huygens/icon-play-audio.svg": "d8e1",
	"./huygens/icon-play-video.svg": "b34d",
	"./huygens/icon-play.svg": "2dde",
	"./huygens/icon-position.svg": "dd81",
	"./huygens/icon-route-remove.svg": "b06c",
	"./huygens/icon-route.svg": "aed9",
	"./huygens/icon-search.svg": "6a0d",
	"./huygens/icon-selected-route.svg": "7c92",
	"./huygens/icon-selected-theme.svg": "e5bb",
	"./huygens/icon-theme-remove.svg": "5dfa",
	"./huygens/icon-timeline-selected.svg": "60de",
	"./huygens/map-footer-gradiant.svg": "6272",
	"./huygens/timeline-bottom.svg": "c1dfa",
	"./huygens/timeline-middle.svg": "9b6d",
	"./huygens/timeline-top.svg": "4946",
	"./icon-5D-items-selected.svg": "47b7",
	"./icon-arrow-left.svg": "6361",
	"./icon-arrow-right.svg": "8e62",
	"./icon-close.svg": "841d",
	"./icon-download-appstore.svg": "dd9b",
	"./icon-download-playstore.svg": "4c4b",
	"./icon-info.svg": "83abd",
	"./icon-lang-en.svg": "8118",
	"./icon-lang-nl.svg": "e2bf",
	"./icon-link.svg": "60ab",
	"./icon-message.svg": "a8bd",
	"./icon-next-10s.svg": "5490",
	"./icon-placeholder.svg": "aac6",
	"./icon-prev-10s.svg": "99e8",
	"./icon-share.svg": "e79c",
	"./timeline-bottom.svg": "d95e",
	"./timeline-middle.svg": "1ace",
	"./timeline-top.svg": "7d93"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a107";